import type { VisibilityScore } from '@lensora/shared'
import { useQuery } from '@tanstack/react-query'


import { api } from '@/lib/api'

export interface VisibilityOverview {
  website_id: string
  latest: VisibilityScore | null
  history: VisibilityScore[]
}

export function useVisibilityOverview(websiteId: string | null, limit = 30) {
  return useQuery({
    queryKey: ['visibility-overview', websiteId, limit],
    queryFn: () =>
      api.get<VisibilityOverview>(`/api/insights/overview?website_id=${websiteId}&limit=${limit}`),
    enabled: !!websiteId,
    staleTime: 30_000,
  })
}
